const NAMESPACE = "inquiry-thread";

const KEYS = {
    addReplyColMsg: "addReplyColMsg",
    remainingCharMsg: "remainingCharMsg",
    currentInqStatusMsg: "currentInqStatusMsg",
    selectText: "selectText",
    gotoViewEditMsg: "gotoViewEditMsg",
    gotoAdminMsg: "gotoAdminMsg",
    changeInqStatusMsg: "changeInqStatusMsg",
    addReplyMsg: "addReplyMsg",
    replyCannotBeBlank: "replyCannotBeBlank",
    openStatusesMsg: "openStatusesMsg",
    closedStatusesMsg: "closedStatusesMsg",
    selectNewStatusMsg: "selectNewStatusMsg",
    threadSmsNotificationsMsg: "threadSmsNotificationsMsg",
    modifySmsNotificationsLabel: "modifySmsNotificationsLabel",
    noVerifiedPhoneNumberMsg: "noVerifiedPhoneNumberMsg"
};

const MESSAGES = {
    [KEYS.addReplyColMsg]: {
        value: "Add Reply:",
        comment: "Header text for reply box."
    },
    [KEYS.remainingCharMsg]: {
        value: "Remaining Characters: {charactersRemaining}",
        comment: "Message for alerting user how many allowed characters are left."
    },
    [KEYS.currentInqStatusMsg]: {
        value: "Current inquiry status: {inqStatus}",
        comment: "Header for inquiry status."
    },
    [KEYS.selectText]: {
        value: "Select...",
        comment: "Dropdown option when no choice has been made."
    },
    [KEYS.gotoViewEditMsg]: {
        value: "Go To View/Edit Page",
        comment: "Button label for redirect to view/edit page."
    },
    [KEYS.gotoAdminMsg]: {
        value: "Go To Admin Page",
        comment: "Button label for redirect to admin page."
    },
    [KEYS.changeInqStatusMsg]: {
        value: "Change Inquiry Status",
        comment: "Button label for changing inquiry status."
    },
    [KEYS.addReplyMsg]: {
        value: "Add Reply",
        comment: "Button label for reply."
    },
    [KEYS.replyCannotBeBlank]: {
        value: "Reply cannot be blank.",
        comment: "Warning when reply message is blank."
    },
    [KEYS.openStatusesMsg]: {
        value: "Open Statuses",
        comment: "Dropdown option for open statuses."
    },
    [KEYS.closedStatusesMsg]: {
        value: "Closed Statuses",
        comment: "Dropdown option for closed statuses."
    },
    [KEYS.selectNewStatusMsg]: {
        value: "Select new inquiry status:",
        comment: "Title for inquiry status dropdown."
    },
    [KEYS.threadSmsNotificationsMsg]: {
        value: "Modify SMS notifications for this inquiry thread",
        comment: "Button label for Thread SMS notifications."
    },
    [KEYS.modifySmsNotificationsLabel]: {
        value: "Enable SMS notifications for this inquiry thread",
        comment: "Modify Sms notifications checkbox"
    },
    [KEYS.noVerifiedPhoneNumberMsg]: {
        value: "No verified phone number available. Go to the My Account page to verify a phone number.",
        comment: "Message when no verified phone number is available."
    }
};

export { KEYS, NAMESPACE, MESSAGES };
